
let styles = {
  container: {
    padding: '3%',
    display: 'flex',
    justifyContent: 'center',
  },

  table: {
    backgroundColor: 'white',
    padding: '1%',
    marginBottom:'25px',
    overflowX:'auto'
  },

  items: {
    padding: '1%',
  },

  item_header: {
    fontSize: '120%',
    fontWeight: 600,
    paddingLeft: '10%',
  },
  input_button:{
    marginRight:'4px'
  },

  item_body: {
    padding: '6px ',
  },

  main_header: {
    padding: '1%',
    marginBottom: '3%',
    backgroundColor: '#84DCF2',
  },
  sub_header: {
    borderBottom:'1px solid',
    textAlign:'left',
    fontSize:'20px',
    fontWeight:'bold',
    marginBottom:'15px',
  },

  button_submit: {
    padding: '1%',
    justifyContent: 'center',
    display: 'flex',
    paddingTop: '6%',
  },

  input: {
    width: '50%',
  },
  button_view:{
    paddingTop:'25px',
    paddingRight:'40px',
    textAlign:"right"
  },

  success: {
    textAlign: 'center',
    fontSize: '120%',
    fontWeight: 800,
  }
}
export default styles



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/viewCompetitionTeam/style.js